const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export const API_URL = isLocal
  ? 'http://localhost:3002'
  : 'https://api.nexslot.synaptix-solutions.com';

export const FRONTEND_URL = isLocal
  ? `${window.location.origin}/#`
  : `${window.location.origin}/#`;
